'use strict';

app.controller('ServiceCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $ngConfirm, toaster) {
        $scope.SERVICE_TAB = 1;
        $scope.VEHICLES_TAB = 2;

        $scope.tab = $scope.VEHICLES_TAB;
        $scope.loading = false;
        $scope.form = false;
        $scope.vehicleForm = false;

        $scope.maintenanceTypes = [];
        $scope.vehicles = [];

        $scope.pagination = {
            current: 1,
        };

        $scope.search = '';

        $scope.options = {
            conditions: ['date', 'working', 'odometer', 'gps'],
            objects: [],
        };

        $scope.selected = {
            maintenanceType: {
                condition: $scope.options.conditions[0],
                code: '',
                name: '',
            },
            maintenance: {
                data: {},
            },
        };
        $scope.initial = angular.copy($scope.selected);

        $scope.changeTab = function(v) {
            $scope.form = false;
            $scope.tab = v;
        };

        $scope.isServiceTab = function() {
            return $scope.tab == $scope.SERVICE_TAB;
        };

        $scope.isVehiclesTab = function() {
            return $scope.tab == $scope.VEHICLES_TAB;
        };

        $scope.toggleForm = function() {
            $scope.form = !$scope.form;
        };

        $scope.isVisibleForm = function() {
            return $scope.form;
        };

        $scope.toggleVehicleForm = function(id) {
            $scope.vehicleForm = $scope.vehicleForm === id ? false : id;
            $scope.resetVehicleForm(true, id);
        };

        $scope.isVisibleVehicleForm = function(id) {
            return $scope.vehicleForm === id;
        };

        $scope.go = function(page, search) {
            $scope.getMaintenances(page, search);
        };

        $scope.editModeEntry = false;

        $scope.isInEditMode = function(maintenance) {
            return $scope.editModeEntry.id === maintenance.id;
        };

        $scope.goToEditMode = function(maintenance) {
            $scope.editModeEntry = maintenance;
        };

        $scope.cancelEditMode = function() {
            $scope.editModeEntry = false;
        };

        $scope.resetVehicleForm = function(bool, id) {
            $scope.selected.maintenance.data = {};

            if ($scope.maintenanceTypes.length && bool) {
                $scope.selected.maintenance.maintenanceType = $scope.maintenanceTypes[0];
            }

            if (!$scope.selected.maintenance.maintenanceType) {
                return;
            }

            var condition = $scope.selected.maintenance.maintenanceType.condition || {};

            if ($scope.vehicleForm && condition !== void 0 && condition === 'odometer') {
                var i = $scope.vehicles.findIndex(function(o) {
                    return o.id === id;
                });

                $scope.selected.maintenance.data.done = 0;

                if (i >= 0) {
                    getVehicleOdometer(id).then(function(distance) {
                        $scope.selected.maintenance.data.done = distance;
                    });
                }
            }
        };

        $scope.ngConfirmMaintenanceModal = {};

        $scope.extendMaintenanceModal = function(maintenance) {
            $scope.ngConfirmMaintenanceModal = {
                maintenance: maintenance,
                data: {
                    done: null,
                    remind: null,
                    expired: null,
                },
                now: false,
                suggest: function() {
                    var id = maintenance.id;
                    var endpoint = `/rest-api/ms/maintenance/api/maintenance/${id}/suggestion`;

                    $http
                        .get(endpoint, { params: { now: $scope.ngConfirmMaintenanceModal.now } })
                        .then(function(response) {
                            var data = response.data.suggestion;

                            switch (maintenance.maintenanceType.condition) {
                                case 'date':
                                    $scope.ngConfirmMaintenanceModal.data.done = moment(data.done);
                                    $scope.ngConfirmMaintenanceModal.data.remind = moment(data.remind);
                                    $scope.ngConfirmMaintenanceModal.data.expired = moment(data.expired);

                                    break;

                                case 'working':
                                    $scope.ngConfirmMaintenanceModal.data.done = moment(data.done);
                                    $scope.ngConfirmMaintenanceModal.data.remind = data.remind;
                                    $scope.ngConfirmMaintenanceModal.data.expired = data.expired;

                                    break;

                                default:
                                    $scope.ngConfirmMaintenanceModal.data.done = data.done;
                                    $scope.ngConfirmMaintenanceModal.data.remind = data.remind;
                                    $scope.ngConfirmMaintenanceModal.data.expired = data.expired;
                            }
                        });
                },
            };

            $scope.ngConfirmMaintenanceModal.suggest();

            var instance = null;

            instance = $ngConfirm({
                title: $translate.instant('service.extend.header'),
                contentUrl: 'tpl/pages/service/modals/extend.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-date pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.ok'),
                        btnClass: 'btn-info',
                        action: function() {
                            var validation = $scope.__validate($scope.ngConfirmMaintenanceModal);

                            if (validation !== true) {
                                toaster.error(
                                    $translate.instant('service.toastr.error.header'),
                                    $translate.instant('service.toastr.error.' + validation)
                                );

                                return false;
                            }

                            $scope
                                .extendMaintenance(
                                    $scope.ngConfirmMaintenanceModal.maintenance.id,
                                    $scope.ngConfirmMaintenanceModal.data
                                )
                                .then(
                                    function() {
                                        $scope.getMaintenances($scope.pagination.current);

                                        instance.close();
                                    },
                                    function(err) {
                                        var translation = err.status === 422 ? 'gt' : 'header';

                                        toaster.error(
                                            $translate.instant('service.toastr.error.header'),
                                            $translate.instant(`service.toastr.error.${translation}`)
                                        );
                                    }
                                );

                            return false;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        /**
         * api - odometer
         */

        var getVehicleOdometer = function(id) {
            return $http.get('/api/node/object/odometer', { params: { object: id } }).then(function(response) {
                var distance = ((response.data || {}).data || {}).Value;

                return distance !== void 0 ? distance : 0;
            });
        };

        /**
         * api - maintenance types
         */

        $scope.getMaintenanceTypes = function() {
            $scope.loading = true;
            var endpoint = '/rest-api/ms/maintenance/api/maintenance-type';

            $http.get(endpoint).then(
                function(response) {
                    $scope.maintenanceTypes = typeof response.data !== 'undefined' ? response.data : [];

                    $scope.resetVehicleForm(true);
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.updateMaintenanceType = function(payload) {
            var id = payload.id;
            var endpoint = `/rest-api/ms/maintenance/api/maintenance-type/${id}`;

            $http.patch(endpoint, payload).then(function() {
                $scope.getMaintenanceTypes();
                $scope.selected.maintenanceType = angular.copy($scope.initial.maintenanceType);
            });
        };

        $scope.createMaintenanceType = function() {
            var endpoint = '/rest-api/ms/maintenance/api/maintenance-type';
            var payload = $scope.selected.maintenanceType;

            $http.post(endpoint, payload).then(function() {
                $scope.getMaintenanceTypes();
                $scope.selected.maintenanceType = angular.copy($scope.initial.maintenanceType);
            });
        };

        $scope.deleteMaintenanceType = function(id) {
            var endpoint = `/rest-api/ms/maintenance/api/maintenance-type/${id}`;

            $http.delete(endpoint).then(function() {
                $scope.getMaintenanceTypes();
                $scope.getMaintenances($scope.pagination.current);
            });
        };

        /**
         * api - maintenances
         */

        $scope.getMaintenances = function(page, search) {
            $scope.loading = true;
            var endpoint = '/rest-api/ms/maintenance/api/maintenance';

            var params = {
                page: page,
                group: $scope.app?.group?.id ? $scope.app.group.id : -1,
            };

            if (search) {
                params.search = search;
            }

            $http
                .get(endpoint, {
                    params: params,
                })
                .then(
                    function(response) {
                        var result = response.data;

                        $scope.vehicles = result.results;
                        $scope.pagination = result.pagination;

                        $scope.__afterGetMaintenances();
                        $scope.loading = false;
                    },
                    function() {
                        $scope.loading = false;
                    }
                );
        };

        $scope.deleteMaintenance = function(id) {
            var endpoint = `/rest-api/ms/maintenance/api/maintenance/${id}`;

            $http.delete(endpoint).then(function() {
                $scope.getMaintenances($scope.pagination.current);
            });
        };

        $scope.extendMaintenance = function(id, data) {
            var endpoint = `/rest-api/ms/maintenance/api/maintenance/${id}/done`;

            return $http.post(endpoint, { data: data });
        };

        /**
         * maintenances - functions
         */

        $scope.__afterGetMaintenances = function() {
            for (var i in $scope.vehicles) {
                var vehicle = $scope.vehicles[i];

                for (var j in vehicle.maintenances) {
                    var maintenance = vehicle.maintenances[j];

                    ['done', 'remind', 'expired'].map(function(item) {
                        switch (maintenance.maintenanceType.condition) {
                            case 'date':
                                $scope.vehicles[i].maintenances[j].data[item] = moment(
                                    $scope.vehicles[i].maintenances[j].data[item]
                                );

                                break;
                        }
                    });

                    switch (maintenance.maintenanceType.condition) {
                        case 'working':
                            $scope.vehicles[i].maintenances[j].data.done = moment(
                                $scope.vehicles[i].maintenances[j].data.done
                            );

                            break;
                    }
                }
            }
        };

        $scope.__beforeMaintenanceSave = function(payload) {
            var result = {
                data: {},
                maintenanceType: payload.maintenanceType,
            };

            ['done', 'remind', 'expired'].map(function(item) {
                switch (payload.maintenanceType.condition) {
                    case 'date':
                        var time =
                            item === 'remind' ? payload.data[item].startOf('day') : payload.data[item].endOf('day');

                        result.data[item] = time.format('YYYY-MM-DD HH:mm:ss');

                        break;
                    case 'odometer':
                    case 'gps':
                        result.data[item] = parseFloat(payload.data[item]);

                        break;
                }
            });

            switch (payload.maintenanceType.condition) {
                case 'working':
                    result.data.done = payload.data.done.format('YYYY-MM-DD HH:mm:ss');
                    result.data.remind = parseFloat(payload.data.remind);
                    result.data.expired = parseFloat(payload.data.expired);

                    break;
            }

            return result;
        };

        $scope.__validate = function(payload) {
            if (!payload.data.done || !payload.data.remind || !payload.data.expired) {
                return 'fillup';
            }

            return true;
        };

        $scope.updateMaintenance = function(vehicleId, id, payload) {
            var endpoint = `/rest-api/ms/maintenance/api/maintenance/${id}`;

            var validation = $scope.__validate(payload);

            if (validation !== true) {
                toaster.error(
                    $translate.instant('service.toastr.error.header'),
                    $translate.instant('service.toastr.error.' + validation)
                );

                return false;
            }

            payload = $scope.__beforeMaintenanceSave(payload);

            var data = {
                data: payload.data,
            };

            $http.patch(endpoint, data).then(
                function() {
                    $scope.getMaintenances($scope.pagination.current);
                    $scope.resetVehicleForm(true, vehicleId);

                    $scope.cancelEditMode();
                },
                function(err) {
                    var translation = err.status === 422 ? 'gt' : 'header';

                    toaster.error(
                        $translate.instant('service.toastr.error.header'),
                        $translate.instant(`service.toastr.error.${translation}`)
                    );

                    return false;
                }
            );
        };

        $scope.createMaintenance = function(vehicleId) {
            var endpoint = '/rest-api/ms/maintenance/api/maintenance';
            var payload = $scope.selected.maintenance;

            var validation = $scope.__validate(payload);

            if (validation !== true) {
                toaster.error(
                    $translate.instant('service.toastr.error.header'),
                    $translate.instant('service.toastr.error.' + validation)
                );

                return false;
            }

            payload = $scope.__beforeMaintenanceSave(payload);

            var data = {
                vehicleId: vehicleId,
                data: payload.data,
                status: 'done',
                maintenanceTypeId: payload.maintenanceType.id,
            };

            $http.post(endpoint, data).then(
                function() {
                    $scope.getMaintenances($scope.pagination.current);
                    $scope.resetVehicleForm(true, vehicleId);

                    $scope.cancelEditMode();
                },
                function(err) {
                    var translation = err.status === 422 ? 'gt' : 'header';

                    toaster.error(
                        $translate.instant('service.toastr.error.header'),
                        $translate.instant(`service.toastr.error.${translation}`)
                    );
                }
            );
        };

        $scope.init = function() {
            $scope.getMaintenanceTypes();
            $scope.getMaintenances($scope.pagination.current);
        };

        $scope.init();
    },
]);
